/*
 * @Author: chenting chenting@cqliving.com
 * @Date: 2022-08-08 10:56:54
 * @LastEditors: chenting chenting@cqliving.com
 * @LastEditTime: 2022-08-11 17:38:54
 * @FilePath: \share-news-detail-pages\src\common\request.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import qs from "qs";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: false,
  timeout: 9000
});

service.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    config.data = config.data ? config.data : {};
    config.params = config.params ? config.params : {};
    // 从网址的query中拿到vfrom 放到接口上 以便cms能够识别这个标识（主要是cms上的预览功能，有这个vfrom可以给内容）
    let isQuery = qs.parse(location.href.split("#")[1]);
    let queryObj = qs.parse(location.href.split("?")[1]);
    let vfrom = isQuery ? isQuery["vfrom"] : "";
    let k = isQuery ? isQuery["k"] : "";
    if (config.method === "get") {
      if (vfrom) {
        config.params = Object.assign(config.params, { vfrom });
      }
      if (k) {
        config.params = Object.assign(config.params, { k });
      }
    } else {
      if (vfrom) {
        config.data = Object.assign(config.data, { vfrom });
      }
      if (k) {
        config.data = Object.assign(config.data, { k });
      }
    }
    config.data = qs.stringify(config.data);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (resp: any) => {
    // TODO http异常代码处理
    // TODO 接口自定义请求异常处理
    // if (location.href.split('#')[1].indexOf('404') == -1){
    //   let url404 = location.href.split('#')[0] + '#/404/404'
    //   window.location.replace(url404)
    // }
    // 必须是详情接口 且为code正确
    // let condition: boolean | null =
    //   /infoDetailNew|getActNewsInfo|detail|specialDetail/.exec(
    //     resp.config.url
    //   ) &&
    //   (resp.data.code === -106000103 || resp.data.code === -1);
    // if (condition) {
    //   // 非404页面
    //   if (location.href.split("#")[1].indexOf("404") === -1) {
    //     let url404 = location.href.split("#")[0] + "#/404/404";
    //     window.location.replace(url404);
    //   }
    // }
    return resp.data;
  },
  error => {
    console.log("response error: ", error); // for debug
    return Promise.reject(error);
  }
);

export default service;
